export enum ImageSize {
  Small,
  Large,
}
